// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo-holder[data-v-2f737678]{width:72px;height:72px}.adjust-some[data-v-2f737678]{-webkit-transform:translateY(-3px);transform:translateY(-3px)}", ""]);
